import store from '../store'

const toggleActiveListItem = () => {
  let allActiveListItems = Array.prototype.slice.call(document.getElementsByClassName('active-li-retraido'))
  allActiveListItems.map(activeListItem => activeListItem.classList.remove('active-li-retraido'))
  if (store.getters.selectedMenuItem) {
    document.getElementById(store.getters.selectedMenuItem).classList.add('active-li-retraido')
  }
}

export default toggleActiveListItem



// WEBPACK FOOTER //
// ./client/utils/toggleActiveListItem.js